import React, { useEffect, useMemo } from "react";
import useState from "react-usestateref";
import { Button } from "@material-ui/core";
import { Helmet } from "react-helmet";
import { choose_Blog_page_Details } from "../config/apiCall";
import { get_Catagory } from "../config/apiCall";
import { choose_Catagory } from "../config/apiCall";
import httpService from "../config/httpCall";
import { search_list } from "../config/apiCall";
import { blog_contact_details } from "../config/apiCall";
import { toastAlert } from "../config/toastAlert";
import PhoneInput from "react-phone-input-2";
import { related_blog } from "../config/apiCall";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import countryList from "react-select-country-list";
import { useLocation } from "react-router-dom";

import {
  FacebookShareButton,
  LinkedinShareButton,
  PinterestShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  PinterestIcon,
  LinkedinIcon,
  TelegramIcon,
  XIcon,
} from "react-share";
import NewFooter from "./landing/NewFooter";
import NewHead from "./landing/NewHead";

function Home() {
  const initialFormValue = {
    name: "",
    email: "",
    phoneNumber: "",
    country: "",
    socialContact: "",
    message: "",
  };

  const [blog, setBlog] = useState([]);
  const [catagory, setCatagory] = useState([]);
  const [chooseCatagory, setChooseCatagory] = useState([]);
  const [search, setsearch] = useState(1);
  const [searchField, setSearchField] = useState("false");
  const [count, setCount] = useState(5);
  const [formValue, setFormValue] = useState(initialFormValue);
  const { name, email, phoneNumber, country, socialContact, message } =
    formValue;
  const [mobileValue, setMobileValue] = useState();
  const [vallidationNameErr, setVallidationNameErr] = useState(false);
  const [getblog, setgetblog, getblogref] = useState();
  const [vallidationEmailErr, setVallidationEmailErr] = useState(false);
  const [vallidationPhoneNumberErr, setVallidationPhoneNumberErr] =
    useState(false);
  const [vallidationcountryErr, setVallidationcountryErr] = useState(false);
  const [vallidationmessageErr, setVallidationmessageErr] = useState(false);
  const [vallidationSocialContact, setVallidationSocialContact] =
    useState(false);
  const [vallidation, setVallidation] = useState(false);
  const [relatedBlog, setRelatedBlog] = useState([]);

  var urls = window.location.href;
  var urlsplit = urls.split("/").at(3);
  const location = useLocation();
  const canonicalUrl = `https://www.beleaftechnologies.com${location.pathname}`;
  useEffect(() => {
    choose_Blog_page(0);
    get_Catagory_Details(0);

    if (getblogref.current == false) {
      get_Catagory_Details(0);
    }
  }, [0]);
  const get_Catagory_Details = async (view) => {
    setpageloader(true);

    var data = {
      apiUrl: httpService.get_Catagory,
    };
    var resp = await get_Catagory(data);
    setCatagory(resp.Message.get_Catagory);
    setpageloader(false);
  };
  let navigate = useNavigate();
  const [pageloader, setpageloader] = useState("false");

  const choose_Blog_page = async () => {
    setpageloader(true);
    var obj = {
      url: urlsplit,
    };
    var data = {
      apiUrl: httpService.choose_Blog_page_Details,
      payload: obj,
    };
    var resp = await choose_Blog_page_Details(data);
    setpageloader(false);

    if (resp.status == false) {
      setgetblog(false);
      navigate("*");
    } else {
      setgetblog(true);
      setBlog(resp.Message.findblog);
      setCount(resp.Message.count);
      var catagaryobj = {
        catagory: resp.Message.findblog.catagaryUrl,
      };
      var data = {
        apiUrl: httpService.related_blog,
        payload: catagaryobj,
      };
      var resp = await related_blog(data);
      setRelatedBlog(resp.Message.relatedbloglist);
    }
  };
  const choose = async (e) => {
    var choosecatory = e.target.innerHTML;
    var obj = {
      choosecatory,
    };
    var data = {
      apiUrl: httpService.choose_Catagory,
      payload: obj,
    };
    var resp = await choose_Catagory(data);
    setChooseCatagory(resp.Message.choosecatagory);
  };
  const searcharea = async (data) => {
    var obj = {
      search: data,
    };
    var data = {
      apiUrl: httpService.search_list,
      payload: obj,
    };
    var resp = await search_list(data);
    setSearchField(true);

    setCatagory(resp.Message.findblog);
  };
  const handleChange = async (e) => {
    try {
      e.preventDefault();
      const { name, value } = e.target;
      let formData = { ...formValue, ...{ [name]: value } };
      setFormValue(formData);
    } catch (error) {}
  };
  const vallidate = async () => {
    try {
      const errors = {};
      if (formValue.name == "") {
        setVallidationNameErr(true);
        errors.name = "Must Enter Your Name";
      } else {
        setVallidationNameErr(false);
      }
      if (formValue.email == "") {
        setVallidationEmailErr(true);
        errors.email = "Must Enter Your Email";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formValue.email)
      ) {
        setVallidationEmailErr(true);
        errors.email = "Invalid Email";
      } else {
        setVallidationEmailErr(false);
      }
      if (formValue.phoneNumber == "") {
        setVallidationPhoneNumberErr(true);
        errors.phoneNumber = "Must Enter Your phoneNumber";
      } else {
        setVallidationPhoneNumberErr(false);
      }
      if (formValue.country == "") {
        setVallidationcountryErr(true);
        errors.country = "Must Enter Your country";
      } else {
        setVallidationcountryErr(false);
      }
      if (formValue.message == "") {
        setVallidationmessageErr(true);
        errors.message = "Must Enter Your country";
      } else {
        setVallidationmessageErr(false);
      }
      if (formValue.socialContact == "") {
        setVallidationSocialContact(true);
        errors.socialContact = "Must Enter Your socialContact";
      } else {
        setVallidationSocialContact(false);
      }
      setVallidation(errors);
    } catch {}
  };

  const [value, setValue] = useState("");
  const options = useMemo(() => countryList().getData(), []);

  const changeHandler = (value) => {
    setValue(value);
    formValue.country = value.label;
  };

  const submit = async () => {
    try {
      formValue.phoneNumber = mobileValue;
      vallidate(formValue);
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formValue.email)) {
        vallidate(formValue);
      } else {
        if (
          formValue.name != "" &&
          formValue.email != "" &&
          formValue.phoneNumber != "" &&
          formValue.country != "" &&
          formValue.message != ""
          // formValue.socialContact != ""/
        ) {
          var data = {
            apiUrl: httpService.blog_contact_details,
            payload: formValue,
          };
          var resp = await blog_contact_details(data);
          toastAlert("success", resp.Message);
        } else {
        }
      }
    } catch (error) {
      console.log(error, "----------");
    }
  };
  const [sharestatus, setsharestatus] = useState(true);
  const share = () => {
    if (sharestatus == true) {
      setsharestatus(false);
    } else {
      setsharestatus(true);
    }
  };
  return (
    <>
      {pageloader == true ? (
        <div className="nodata">
          <img
            className=" mx-auto d-block"
            src={require("../image/load2.gif")}
          ></img>
        </div>
      ) : getblogref.current == true ? (
        <div className="blog_header">
          <header className="newpage nft_new_page  p-0">
            <Helmet>
              <meta name="robots" content="index, dofollow"></meta>
              <title>{blog.title}</title>
              {/* <link
                rel="canonical"
                href={canonicalUrl}
                // href={`https://beleaftechnologies.com/${blog.slug}`}
              /> */}
              <meta name="title" content={blog.title} />
              <meta name="description" content={blog.metadescription} />
              <meta property="og:title" content={blog.title} />
              <meta property="og:site_name" content="Beleaf Technologies" />
              {/* <meta property="og:url" content={blog.image} /> */}
              <meta property="og:description" content={blog.metadescription} />
              <meta property="og:type" content="website" />
              <meta property="og:image" content={blog.image} />
              <meta name="twitter:card" content="summary" />
              <meta name="twitter:site" content="@BeleafTech" />
              <meta name="twitter:title" content={blog.title} />
              <meta name="twitter:description" content={blog.metadescription} />
              <meta name="twitter:image" content={blog.image} />
              <meta name="twitter:image:alt" content="Beleaf Technologies" />
            </Helmet>
            {/* <Header /> */}
            <NewHead />
          </header>
          <main className="pading_dsds">
            <section className="blog_heading_section">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="links_blog">
                      <div>
                        <h3>Blogs</h3>
                      </div>
                      <div>
                        <a href="/">Home</a>
                        <span>
                          <i className="bi bi-caret-right"></i>
                        </span>
                        <a href="/blog_details" className="">
                          Blogs
                        </a>
                        <span>
                          <i className="bi bi-caret-right"></i>
                        </span>
                        <a href="/" className="current">
                          {blog.metatitle}{" "}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div className="container">
              <div className="row">
                <div className="col-lg-9">
                  <div className="image_conainer">
                    <img src={blog.image} />
                  </div>
                  <div className="blog_header">
                    <h1>{blog.title}</h1>
                    <div className="content_blog p-0">
                      <div className="by_conte">
                        <p>
                          by<strong>{blog.creator} </strong>
                        </p>
                        <span>
                          {moment(blog.createdAt).format("Do MMMM  YYYY")}
                        </span>
                      </div>

                      <div className="icon_secton">
                        <span>
                          <i className="bi bi-eye"></i>
                          {count}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="content_blog_text">
                    <p dangerouslySetInnerHTML={{ __html: blog.content }}></p>
                  </div>
                  <div className="share_section justify-content-center">
                    {sharestatus == true ? (
                      <Button onClick={share}>
                        <i className="bi bi-share"></i>Share
                      </Button>
                    ) : (
                      <div className="d-flex">
                        <div className="link_section AlignD" onClick={share}>
                          <a>
                            <img
                              className="imageadjust"
                              src={require("../image/copy.png")}
                            ></img>
                          </a>
                        </div>

                        <div className="link_section AlignD">
                          <a>
                            <FacebookShareButton
                              url={urls}
                              quote={"Dummy text!"}
                              hashtag="#muo"
                            >
                              <FacebookIcon size={32} round />
                            </FacebookShareButton>
                          </a>
                        </div>

                        <div className="link_section AlignD">
                          {/* <a>
                            <TwitterShareButton
                              url={urls}
                              quote={"Dummy text!"}
                              hashtag="#muo"
                            >
                              <TwitterIcon size={32} round />
                            </TwitterShareButton>
                          </a> */}
                          <a>
                            <TwitterShareButton
                              url={urls}
                              quote={"Dummy text!"}
                              hashtag="#muo"
                            >
                              <XIcon size={32} round />
                            </TwitterShareButton>
                          </a>
                        </div>
                        <div className="link_section  AlignD">
                          <a>
                            <WhatsappShareButton
                              url={urls}
                              quote={"Dummy text!"}
                              hashtag="#muo"
                            >
                              <WhatsappIcon size={32} round />
                            </WhatsappShareButton>
                          </a>
                        </div>
                        {/* <div className="link_section AlignD">
                          <a>
                            <PinterestShareButton
                              url={urls}
                              quote={"Dummy text!"}
                              hashtag="#muo"
                            >
                              <PinterestIcon size={32} round />
                            </PinterestShareButton>
                          </a>
                        </div> */}
                        <div className="link_section AlignD">
                          <a>
                            <LinkedinShareButton
                              url={urls}
                              quote={"Dummy text!"}
                              hashtag="#muo"
                            >
                              <LinkedinIcon size={32} round />
                            </LinkedinShareButton>
                          </a>
                        </div>
                        <div className="link_section AlignD">
                          <a>
                            <TelegramShareButton
                              url={urls}
                              quote={"Dummy text!"}
                              hashtag="#muo"
                            >
                              <TelegramIcon size={32} round />
                            </TelegramShareButton>
                          </a>
                        </div>
                        <div className="link_section AlignD" onClick={share}>
                          <a>
                            {/* <img
                              className="imageadjust"
                              src={require("../image/closeicon.png")}
                            ></img> */}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 32 32"
                              id="Close"
                              className="imageadjust"
                            >
                              <path
                                d="M17 2C8.716 2 2 8.716 2 17s6.716 15 15 15 15-6.716 15-15S25.284 2 17 2zm6.95 9.464-5.574 5.574 4.932 5.498a1 1 0 0 1-1.414 1.414l-4.932-5.498-5.498 5.498a1 1 0 0 1-1.414-1.414l5.574-5.574-4.932-5.498a1 1 0 0 1 1.414-1.414l4.932 5.498 5.498-5.498a1 1 0 0 1 1.414 1.414z"
                                fill="#ff0900"
                                className="color000000 svgShape"
                              ></path>
                            </svg>
                          </a>
                        </div>
                      </div>
                    )}

                    {/* <div className="footer_menyu_sss"> */}

                    <div></div>
                  </div>
                  <div className="related_post">
                    <h3>Related Posts</h3>

                    <div className="row">
                      {relatedBlog && relatedBlog.length > 0
                        ? relatedBlog.map((item, i) => {
                            return (
                              <div className="col-lg-4">
                                <div className="blog_card">
                                  <div className="blog_img">
                                    <img src={item.image} />
                                  </div>
                                  <div className="conyente_blog">
                                    <h4>{item.title}</h4>
                                    <a href={`/${item.slug}`}>
                                      {item.category}
                                    </a>
                                  </div>
                                  <div className="footer11">
                                    <a href={`/${item.slug}`} target="_blank">
                                      Read more{" "}
                                      <i className="bi bi-caret-right "></i>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        : "Not Related Post Uptain"}
                    </div>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="form_search">
                    <input
                      type="text"
                      placeholder="search"
                      onChange={(e) => searcharea(e.target.value)}
                    />
                    {/* <i className="bi bi-search search"  onClick={() => searcharea()}></i> */}
                  </div>
                  <div className="categorieded">
                    <h3>Categories</h3>
                    {searchField == false ? (
                      <>
                        {catagory.length > 0 ? (
                          catagory.map((item, i) => {
                            return (
                              <ul>
                                <li>
                                  <a
                                    onClick={choose}
                                    target="_blank"
                                    href={`/catogary/${item.categoryurl}`}
                                  >
                                    {item.categoryname}
                                  </a>
                                </li>
                              </ul>
                            );
                          })
                        ) : (
                          <ul>
                            <li>No Category found</li>
                          </ul>
                        )}
                      </>
                    ) : (
                      <>
                        {catagory.length > 0 ? (
                          catagory.map((item, i) => {
                            return (
                              <ul>
                                <li>
                                  <a
                                    onClick={choose}
                                    target="_blank"
                                    href={`/catogary/${item.categoryurl}`}
                                  >
                                    {item.categoryname}
                                  </a>
                                </li>
                              </ul>
                            );
                          })
                        ) : (
                          <ul>
                            <li>No Category found</li>
                          </ul>
                        )}
                      </>
                    )}
                  </div>
                  {/* <div className="categorieded">
                <h3>Recent Posts</h3>
                <ul>
                  <li>
                    <a href="">
                      <i className="bi bi-pencil-square"></i> All
                    </a>
                  </li>
                  <li>
                    <a href="">
                      {" "}
                      <i className="bi bi-pencil-square"></i>Clients
                    </a>
                  </li>

                  <li>
                    <a href="">
                      {" "}
                      <i className="bi bi-pencil-square"></i>Design
                    </a>
                  </li>

                  <li>
                    <a href="">
                      {" "}
                      <i className="bi bi-pencil-square"></i> News
                    </a>
                  </li>
                </ul>
              </div> */}
                  <div className="contect_form_bloh border_radie">
                    <h4>Contact Us</h4>
                    <form>
                      <div className="form-group">
                        <input
                          type="name"
                          className="form-control"
                          id="name"
                          placeholder="Name"
                          min={3}
                          max={25}
                          name="name"
                          onChange={handleChange}
                        />
                        {vallidationNameErr && vallidationNameErr === true ? (
                          <span className="text-danger">
                            {" "}
                            {vallidation.name}{" "}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="form-group">
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          placeholder="Email Address"
                          name="email"
                          value={email}
                          onChange={handleChange}
                        />
                      </div>
                      {vallidationEmailErr && vallidationEmailErr === true ? (
                        <span className="text-danger">
                          {" "}
                          {vallidation.email}{" "}
                        </span>
                      ) : (
                        ""
                      )}
                      <div className="form-group">
                        {/* <input
                      type="phoneNumber"
                      className="form-control"
                      id="phoneNumber"
                      placeholder="Phone Number"
                      name="phoneNumber"
                      value={phoneNumber}
                      onChange={handleChange}
                    /> */}
                        <PhoneInput
                          country={"us"}
                          value={mobileValue}
                          onChange={setMobileValue}
                        />
                      </div>
                      {vallidationPhoneNumberErr &&
                      vallidationPhoneNumberErr === true ? (
                        <span className="text-danger">
                          {" "}
                          {vallidation.phoneNumber}{" "}
                        </span>
                      ) : (
                        ""
                      )}
                      <div className="form-group">
                        <Select
                          placeholder=" select country "
                          options={options}
                          value={value}
                          onChange={changeHandler}
                        />
                      </div>
                      {vallidationcountryErr &&
                      vallidationcountryErr === true ? (
                        <span className="text-danger">
                          {" "}
                          {vallidation.country}{" "}
                        </span>
                      ) : (
                        ""
                      )}
                      {/* <div className="form-group">
                        <input
                          type="socialcontact"
                          className="form-control"
                          id="socialcontact"
                          min={3}
                          max={25}
                          placeholder="Whatsapp/telegram/skype"
                          name="socialContact"
                          value={socialContact}
                          onChange={handleChange}
                        />
                      </div>
                      {vallidationSocialContact &&
                      vallidationSocialContact === true ? (
                        <span className="text-danger">
                          {" "}
                          {vallidation.socialContact}{" "}
                        </span>
                      ) : (
                        ""
                      )} */}

                      <div className="form-group">
                        <input
                          type="message"
                          className="form-control"
                          id="message"
                          placeholder="Message"
                          name="message"
                          value={message}
                          min={3}
                          max={50}
                          onChange={handleChange}
                        />
                      </div>
                      {vallidationmessageErr &&
                      vallidationmessageErr === true ? (
                        <span className="text-danger">
                          {" "}
                          {vallidation.message}{" "}
                        </span>
                      ) : (
                        ""
                      )}
                      <div className="submitbutton">
                        <Button onClick={submit}>Submit</Button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </main>
          {/* <main className="paddin_immner">
        <div className="page-title-area">
          <div className="container">
            <div className="page-title-content">
              <h1>Our Latest Articles</h1>
              <p>Temo is the easiest place to buy and sell cryptocurrency.</p>
            </div>
          </div>
          <div className="lines">
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
          </div>
        </div>

        <div className="blog-details-area ptb-100">
          <div className="container">
            <div className="blog-details-header row align-items-center justify-content-center">
              <div className="col-lg-6 col-md-12">
                <div className="content">
                  <a href="/blog" className="category">
                    Filecoin
                  </a>
                  <h1>
                    How Filecoin is Up 50% in a Week &amp; Could Take More
                    Profits
                  </h1>
                  <p>
                    It is a long established fact that a reader will be
                    distracted by the readable content of a page when looking at
                    its layout.
                  </p>
                  <div className="post-author-meta">
                    <div className="d-flex ">
                      <img
                        src="https://temo-vue.envytheme.com/img/user1.726e3948.jpg"
                        alt="image"
                      />
                      <div className="title">
                        <span className="name">
                          By{" "}
                          <a href="/blog" className="">
                            EnvyTheme
                          </a>
                        </span>
                        <span className="date">March 17, 2021</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12">
                <div className="image">
                  <img
                    src="https://temo-vue.envytheme.com/img/blog1.dabd157f.jpg"
                    alt="image"
                  />
                </div>
              </div>
            </div>
            <div className="blog-details-desc">
                          <div className="article-content">
                            <ul className="social-links">
                              <li>
                                <a
                                  href="https://www.facebook.com/people/Beleaf-Technologies/100083681051307/"
                                  target="_blank"
                                  className="facebook"
                                >
                                  <i className="fab fa-facebook-f"></i>
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://twitter.com/BeleafTech"
                                  target="_blank"
                                  className="twitter"
                                >
                                  <i className="fab fa-twitter"></i>
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://www.linkedin.com/company/beleaf-technologies-blf/mycompany/"
                                  target="_blank"
                                  className="linkedin"
                                >
                                  <i className="fab fa-linkedin-in"></i>
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://www.instagram.com/beleaftechnologies/"
                                       target="_blank"
                                  className="instagram"
                                >
                                  <i className="fab fa-instagram"></i>
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://web.telegram.org/z/"
                                  target="_blank"
                                  className="telegram"
                                >
                                  <i className="fab fa-telegram"></i>
                                </a>
                              </li>
                              <li>
                                <a
                                  href="skype:live:.cid.62ff8496d3390349"
                                  target="_blank"
                                  className="skype"
                                >
                                  <i className="fab fa-skype"></i>
                                </a>
                              </li>
                              <li>
                                <a
                                  href="https://api.whatsapp.com/message/7LPZZGXW7ZHRO1?autoload=1&app_absent=0"
                                  target="_blank"
                                  className="whatsapp"
                                >
                                  <i className="fab fa-whatsapp"></i>
                                </a>
                              </li>
                              <li>
                                <a
                                  href="mailto:blftechorg@gmail.io"
                                  target="_blank"
                                  className="email"
                                >
                                  <i className="fa fa-email"></i>
                                </a>
                              </li>
                            </ul>
                <p>
                  Quuntur magni dolores eos qui ratione voluptatem sequi
                  nesciunt. Neque porro quia non jgstaa numquam eius modi
                  tempora incidunt ut labore et dolore magnam dolor sit amet,
                  consectetur adipisicing voluptatem sequi nesciunt.
                </p>
                <p>
                  Lorem ipsum dolor sit amet, consectetur{" "}
                  <strong>adipisicing</strong> elit, sed do eiusmod tempor
                  incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                  veniam, quis nostrud exercitation ullamco laboris nisi ut
                  aliquip ex ea <a href="#">commodo</a> consequat. Duis aute
                  irure dolor in reprehenderit in sed quia non numquam eius modi
                  tempora incidunt ut labore et dolore magnam aliquam quaerat
                  voluptatem.
                </p>
                <h3>So, What Exactly is Positioning and Why Does It Matter?</h3>
                <p>
                  Quuntur magni dolores eos qui ratione voluptatem sequi
                  nesciunt. Neque porro quia non numquam eius modi tempora
                  incidunt ut labore et dolore magnam dolor sit amet,
                  consectetur adipisicing.
                </p>
                <ul>
                  <li>a console</li>
                  <li>Two Joy-Con controllers that are detachable</li>
                  <li>
                    A grip that enables you to combine them into a single{" "}
                    <a href="#">gamepad</a> for play on the
                  </li>
                  <li>
                    Two straps for turning the Joy-Cons into individual
                    controllers
                  </li>
                  <li>
                    A dock which you can use to connect your console to the{" "}
                    <strong>television</strong> for traditional gameplay
                  </li>
                </ul>
                <p>
                  Quuntur magni dolores eos qui ratione voluptatem sequi
                  nesciunt. Neque porro quia non jgstaa numquam eius modi
                  tempora incidunt ut labore et dolore magnam dolor sit amet,
                  consectetur adipisicing voluptatem sequi nesciunt.
                </p>
                <h3>How We Defined Our Positioning: a Step-by-Step Overview</h3>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                  irure dolor in reprehenderit in sed quia non numquam eius modi
                  tempora incidunt ut labore et dolore magnam aliquam quaerat
                  voluptatem.
                </p>
                <blockquote className="wp-block-quote">
                  <p>
                    It is a long established fact that a reader will be
                    distracted by the readable when content of a page when
                    looking at its layout.
                  </p>
                  <cite>Tom Cruise</cite>
                </blockquote>
                <p>
                  Lorem Ipsum has been the industry’s standard dummy text ever
                  since the 1500s, when an unknown printer took a galley of type
                  and scrambled it to make a type specimen.
                </p>
                <ul className="wp-block-gallery columns-3">
                  <li className="blocks-gallery-item">
                    <figure>
                      <img
                        src="https://temo-vue.envytheme.com/img/blog4.68d031ec.jpg"
                        alt="image"
                      />
                    </figure>
                  </li>
                  <li className="blocks-gallery-item">
                    <figure>
                      <img
                        src="https://temo-vue.envytheme.com/img/blog4.68d031ec.jpg"
                        alt="image"
                      />
                    </figure>
                  </li>
                  <li className="blocks-gallery-item">
                    <figure>
                      <img
                        src="https://temo-vue.envytheme.com/img/blog4.68d031ec.jpg"
                        alt="image"
                      />
                    </figure>
                  </li>
                </ul>
                <p>
                  Lorem Ipsum has been the industry’s standard dummy text ever
                  since the 1500s, when an unknown printer took a galley of type
                  and scrambled it to make a type specimen.
                </p>
                <ul>
                  <li>Scientific skills for getting a better result</li>
                  <li>Communication skills to getting in touch</li>
                  <li>A career overview opportunity available</li>
                  <li>A good work environment for work</li>
                </ul>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud.
                </p>
                <div className="article-tags">
                  <a href="/blog" className="">
                    #Business
                  </a>
                  <a href="/blog" className="">
                    #Startup
                  </a>
                  <a href="/blog" className="">
                    #Agency
                  </a>
                </div>
                <div className="comment-respond">
                  <h3 className="comment-reply-title">Leave A Reply</h3>
                  <form className="comment-form">
                    <p className="comment-notes">
                      Your email address will not be published. Required fields
                      are marked <span className="required">*</span>
                    </p>
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-6">
                        <div className="form-group">
                          <input
                            type="text"
                            name="name"
                            className="form-control"
                            placeholder="Eg: Sarah Taylor"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6">
                        <div className="form-group">
                          <input
                            type="email"
                            name="email"
                            className="form-control"
                            placeholder="hello@sarah.com"
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="form-group">
                          <input
                            type="text"
                            name="website"
                            className="form-control"
                            placeholder="Website"
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="form-group">
                          <textarea
                            name="message"
                            className="form-control"
                            cols="30"
                            rows="5"
                            placeholder="Comment..."
                          ></textarea>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-5 col-sm-12">
                        <button type="submit" className="default-btn">
                          <i className="fas fa-paper-plane"></i> Post A Comment
                        </button>
                      </div>
                      <div className="col-lg-8 col-md-7 col-sm-12">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="checkme"
                          />
                          <label className="form-check-label" htmlFor="checkme">
                            Save my name, email, and website in this browser for
                            the next time I comment.
                          </label>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="blog-area pt-100 pb-70">
          <div className="container">
            <div className="section-title">
              <h2>You May Also Like</h2>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6">
                <div className="single-blog-post">
                  <div className="post-image">
                    <a
                      aria-current="page"
                      href="/blog-details"
                      className="router-link-active active d-block"
                    >
                      <img
                        src="https://temo-vue.envytheme.com/img/blog1.dabd157f.jpg"
                        alt="image"
                      />
                    </a>
                    <div className="tag-list">
                      <a href="/blog" className="">
                        Filecoin
                      </a>
                    </div>
                  </div>
                  <div className="post-content">
                    <h3>
                      <a
                        aria-current="page"
                        href="/blog-details"
                        className="router-link-active active"
                      >
                        {" "}
                        How Filecoin is Up 50% in a Week &amp; Could Take More
                        Profits{" "}
                      </a>
                    </h3>
                    <p>
                      Borem ipsum dolor sit amet, adhuc iriure dissentias est
                      in, est ne diam graece tincidunt.
                    </p>
                    <div className="author d-flex align-items-center">
                      <img
                        src="https://temo-vue.envytheme.com/img/user1.726e3948.jpg"
                        alt="image"
                      />
                      <a href="/blog" className="">
                        Steven Smith
                      </a>
                    </div>
                    <a
                      aria-current="page"
                      href="/blog-details"
                      className="router-link-active active link-btn"
                    >
                      <i className="fas fa-arrow-right"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-blog-post">
                  <div className="post-image">
                    <a
                      aria-current="page"
                      href="/blog-details"
                      className="router-link-active active d-block"
                    >
                      <img
                        src="https://temo-vue.envytheme.com/img/blog1.dabd157f.jpg"
                        alt="image"
                      />
                    </a>
                    <div className="tag-list">
                      <a href="/blog" className="">
                        Education
                      </a>
                    </div>
                  </div>
                  <div className="post-content">
                    <h3>
                      <a
                        aria-current="page"
                        href="/blog-details"
                        className="router-link-active active"
                      >
                        {" "}
                        Coinbase Releases Investor Education Resources in 2021{" "}
                      </a>
                    </h3>
                    <p>
                      Borem ipsum dolor sit amet, adhuc iriure dissentias est
                      in, est ne diam graece tincidunt.
                    </p>
                    <div className="author d-flex align-items-center">
                      <img
                        src="https://temo-vue.envytheme.com/img/user1.726e3948.jpg"
                        alt="image"
                      />
                      <a href="/blog" className="">
                        Sarah Taylor
                      </a>
                    </div>
                    <a
                      aria-current="page"
                      href="/blog-details"
                      className="router-link-active active link-btn"
                    >
                      <i className="fas fa-arrow-right"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-blog-post">
                  <div className="post-image">
                    <a
                      aria-current="page"
                      href="/blog-details"
                      className="router-link-active active d-block"
                    >
                      <img
                        src="https://temo-vue.envytheme.com/img/blog1.dabd157f.jpg"
                        alt="image"
                      />
                    </a>
                    <div className="tag-list">
                      <a href="/blog" className="">
                        Bitcoin
                      </a>
                    </div>
                  </div>
                  <div className="post-content">
                    <h3>
                      <a
                        aria-current="page"
                        href="/blog-details"
                        className="router-link-active active"
                      >
                        {" "}
                        World’s Largest Bitcoin Conference Coming To Miami in
                        June{" "}
                      </a>
                    </h3>
                    <p>
                      Borem ipsum dolor sit amet, adhuc iriure dissentias est
                      in, est ne diam graece tincidunt.
                    </p>
                    <div className="author d-flex align-items-center">
                      <img
                        src="https://temo-vue.envytheme.com/img/user1.726e3948.jpg"
                        alt="image"
                      />
                      <a href="/blog" className="">
                        David Warner
                      </a>
                    </div>
                    <a
                      aria-current="page"
                      href="/blog-details"
                      className="router-link-active active link-btn"
                    >
                      <i className="fas fa-arrow-right"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main> */}

          {/* <Footer /> */}
          <NewFooter />
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default Home;
